import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CustomMaterialModule } from "@root/custom-material/custom-material.module";
import { PipesModule } from "@root/core/pipes/pipes-module.module";
import { components } from ".";
import { DeleteDialogComponent } from "./delete-dialog/delete-dialog.component";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { NotificationDialogComponent } from "./notification-dialog/notification-dialog.component";
import { FullCalendarModule } from "@fullcalendar/angular";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import "froala-editor/js/plugins.pkgd.min.js";
import { ControlFormsService } from "@services/control-forms.service";
import { FilesDialogComponent } from "./files-dialog/files-dialog.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    CustomMaterialModule,
    PipesModule,
    FullCalendarModule,
    NgxMatSelectSearchModule,
  ],
  declarations: [...components],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    ...components,
    CustomMaterialModule,
  ],
  providers: [ControlFormsService],
  entryComponents: [
    DeleteDialogComponent,
    ConfirmationDialogComponent,
    NotificationDialogComponent,
    FilesDialogComponent,
  ],
})
export class SharedModule {}
